<div class="preference">
  <div class="preference__info">
    <span class="info__label">{{label}}</span>
    <span class="info__description">{{description}}</span>
  </div>
  <div class="preference__content">
    <ng-content></ng-content>
  </div>
</div>
